import React from 'react';
import ReactDOM from 'react-dom/client';
import './App.css';
import App from './App';
import { GoogleOAuthProvider } from "@react-oauth/google";
import { NotificationProvider } from "./notification/NotificationContext";
import { SubscriptionProvider } from "./context/SubscriptionContext";

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
     <NotificationProvider>
      <SubscriptionProvider>
        <App />
      </SubscriptionProvider>
    </NotificationProvider>
  </GoogleOAuthProvider>
);
